import { FC, ReactNode, useEffect, useState } from 'react'
import useLocale from '@/utils/useLocale'
import styles from './styles/index.module.less'
import { Modal } from 'antd-mobile'

const GuideToPC: FC<{ children: ReactNode }> = (props) => {
  const t = useLocale()
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    setVisible(true)
  }, [])

  return (
    <div className={styles.container}>
      {props.children}
      <Modal
        visible={visible}
        className={styles.modal}
        title={t['monitor.jump.tip']}
        content={t['guide.toPC']}
        closeOnAction
        closeOnMaskClick
        onClose={() => {
          setVisible(false)
        }}
        actions={[
          {
            key: 'close',
            text: t['modal.close'],
            className: styles.close
          }
        ]}
      />
    </div>
  )
}

export default GuideToPC
